import React from 'react';
import { BellIcon, WrenchIcon, CheckIcon } from 'lucide-react';
const ARREARS = [{
  unit: 'Nakawa Court · B4',
  tenant: 'A. Mwesigwa',
  days: '3 days late',
  amount: 'UGX 1,200,000'
}, {
  unit: 'Kacyiru Heights · 12',
  tenant: 'J. Uwimana',
  days: '9 days late',
  amount: 'RWF 320,000'
}, {
  unit: 'Ntinda Park · A2',
  tenant: 'S. Nabirye',
  days: '21 days late',
  amount: 'UGX 2,400,000'
}];
const ACTIVITY = [{
  icon: BellIcon,
  text: '48 rent reminders sent across 3 properties',
  time: '06:00'
}, {
  icon: WrenchIcon,
  text: 'Leaking geyser · Ntinda Park A2 assigned to J. Kato',
  time: '08:14'
}, {
  icon: CheckIcon,
  text: 'Payment matched · Bugolobi Rise 07 cleared in full',
  time: '09:02'
}];
export function PropFlowPreview() {
  return <div className="border border-ink-200 bg-white shadow-sm" data-id="element-112" data-mp="3d6xfgtobt8tf">
      <div className="flex items-center justify-between border-b border-ink-100 px-5 py-3" data-id="element-113" data-mp="3d9jvzit72yns">
        <span className="text-xs font-medium uppercase tracking-[0.16em] text-ink-500" data-id="element-114" data-mp="3i8msgev3zwk5">
          PropFlow · Portfolio
        </span>
        <span className="flex items-center gap-2 text-xs text-ink-500" data-id="element-115" data-mp="fg55dqgaje8e">
          <span className="block h-1.5 w-1.5 rounded-full bg-bronze-500" aria-hidden="true" data-id="element-116" data-mp="fhy6yrc1r89j" />
          Automations running
        </span>
      </div>

      <div className="grid gap-px bg-ink-100 sm:grid-cols-3" data-id="element-117" data-mp="ohl6f7l7u3zy">
        {[{
        value: '131',
        label: 'Units managed'
      }, {
        value: '92%',
        label: 'Collected this month'
      }, {
        value: '7',
        label: 'Open maintenance'
      }].map(item => <div key={item.label} className="bg-white px-5 py-5" data-id="element-118" data-mp="ags9kg7fywto">
            <span className="block text-2xl font-semibold tracking-tight text-ink-900" data-id="element-119" data-mp="ai3c6cp5hyj7">
              {item.value}
            </span>
            <span className="mt-1 block text-xs text-ink-500" data-id="element-120" data-mp="3e5vidb5vjtcv">{item.label}</span>
          </div>)}
      </div>

      <div className="border-t border-ink-100 px-5 py-5" data-id="element-121" data-mp="397al9klx5psn">
        <h3 className="text-xs font-medium uppercase tracking-[0.16em] text-ink-500" data-id="element-122" data-mp="394ocxir7f69d">
          Arrears needing attention
        </h3>
        <ul className="mt-3 divide-y divide-ink-100" data-id="element-123" data-mp="1i27aykcocyrg">
          {ARREARS.map(row => <li key={row.unit} className="flex items-center justify-between gap-4 py-2.5" data-id="element-124" data-mp="1mtpeng631dg4">
              <span className="min-w-0" data-id="element-125" data-mp="1qv13hjh4tun9">
                <span className="block truncate text-sm font-medium text-ink-900" data-id="element-126" data-mp="1qtr50t6dakg3">
                  {row.unit}
                </span>
                <span className="block truncate text-xs text-ink-500" data-id="element-127" data-mp="u6uy2ucdyy7x">
                  {row.tenant} · {row.days}
                </span>
              </span>
              <span className="shrink-0 text-sm font-medium text-bronze-700" data-id="element-128" data-mp="134evttb1icds">
                {row.amount}
              </span>
            </li>)}
        </ul>
      </div>

      <div className="border-t border-ink-100 bg-ink-50 px-5 py-5" data-id="element-129" data-mp="2el4yj2g98m2n">
        <h3 className="text-xs font-medium uppercase tracking-[0.16em] text-ink-500" data-id="element-130" data-mp="2emzh4a42023k">
          Today, handled automatically
        </h3>
        <ul className="mt-3 space-y-3" data-id="element-131" data-mp="2tnwmo24ds5mk">
          {ACTIVITY.map(item => <li key={item.text} className="flex items-start gap-3" data-id="element-132" data-mp="2ootu3h5l7rvh">
              <item.icon className="mt-0.5 h-4 w-4 shrink-0 text-bronze-600" aria-hidden="true" data-id="element-133" data-mp="2oqmy0ootfxzs" />
              <span className="text-sm leading-snug text-ink-700" data-id="element-134" data-mp="2fx1l7aw7oqt0">{item.text}</span>
              <span className="ml-auto shrink-0 text-xs text-ink-400" data-id="element-135" data-mp="2awvrlp6dsu8a">{item.time}</span>
            </li>)}
        </ul>
      </div>
    </div>;
}